import moment from 'moment-timezone';

export const usesMembershipV2Credits = booking =>
  booking?.usesMembershipV2Credits === true ||
  booking?.membershipV2CreditSummary?.provider === 'membership_v2' ||
  booking?.familyMembers?.some(member => member?.usesMembershipV2Credits === true) === true;

// Bookings are stored in UTC but the API sends the timestamp without an
// offset ("2026-09-25T19:00"). `new Date(value)` reads that as browser local
// time, which shifts the cancellation deadline by the browser's UTC offset.
const parseBookingStart = value => {
  if (!value) return null;

  const start = moment.utc(value);
  return start.isValid() ? start.toDate() : null;
};

export const classCancellationError = ({companyData, booking, now = new Date()}) => {
  if (companyData?.CTCM === true) {
    return 'Please contact your coach to cancel this Class.';
  }

  const rawHours = companyData?.cancelClassHrs;
  if (rawHours === null || rawHours === undefined || rawHours === '') {
    return 'Please contact your coach to cancel this Class.';
  }

  const hours = Number(rawHours);
  const classStart = parseBookingStart(booking?.start);
  if (!classStart || Number.isNaN(hours)) {
    return 'Unable to determine the class cancellation deadline. Please contact your coach.';
  }

  const cutoff = new Date(classStart.getTime() - hours * 60 * 60 * 1000);
  return now >= cutoff
    ? `Cancellation is not allowed within ${rawHours} hours of the class start.`
    : null;
};

export const clientCanCancelCamp = booking =>
  booking?.isCamp !== true || usesMembershipV2Credits(booking);

export const clientCanCancelCampParticipant = (booking, participant) =>
  booking?.isCamp !== true || participant?.usesMembershipV2Credits === true;
